@if (activeEditorIndex === 0) {
  <form [formGroup]="mailForm">
    <div class="batch-form">
      <div class="form-group">
        <span class="label">Quote validity:</span>
        <div class="validity-range__wrapper">
          <input type="hidden" formControlName="validFrom" />
          <input type="hidden" formControlName="validTo" />
          <div class="validity-range__picker" id="e-batch-quote-validity">
            <app-date-picker
              (rangeChange)="setValidityDates($event)"
              [selectedRange]="validityDates"
              inputClass="p-inputtext"
              [showIcon]="true"
            >
            </app-date-picker>
          </div>
        </div>
      </div>
      <div class="form-group">
        <span class="label">To:</span>
        <p-autocomplete
          formControlName="to"
          (onKeyUp)="onKeyUpField($event, 'to')"
          (onBlur)="onBlurField($event, 'to')"
          [suggestions]="results"
          (completeMethod)="search($event)"
          [showEmptyMessage]="true"
          [multiple]="true"
        >
        </p-autocomplete>
      </div>
      <div class="form-group">
        <span class="label">CC:</span>
        <p-autocomplete
          formControlName="cc"
          (onKeyUp)="onKeyUpField($event, 'cc')"
          (onBlur)="onBlurField($event, 'cc')"
          [suggestions]="results"
          (completeMethod)="search($event)"
          [multiple]="true"
        >
        </p-autocomplete>
      </div>
      <div class="form-group">
        <span class="label">BCC:</span>
        <p-autocomplete
          formControlName="bcc"
          (onKeyUp)="onKeyUpField($event, 'bcc')"
          (onBlur)="onBlurField($event, 'bcc')"
          [suggestions]="results"
          (completeMethod)="search($event)"
          [showEmptyMessage]="true"
          [multiple]="true"
        >
        </p-autocomplete>
      </div>
      <div class="form-group">
        <span class="label">Subject:</span>
        <input type="hidden" formControlName="subject" />
        <app-wysiwyg
          [showPlaceholders]="true"
          [showToolbarItems]="false"
          [value]="mailForm.controls.subject.value"
          (valueChanged)="setField('subject', $event, true)"
          class="form-control floating-header no-padding"
          [class.has-error]="!mailForm.controls.subject.valid"
        >
        </app-wysiwyg>
      </div>
      <div class="form-group form-group--message">
        <span class="label">Message:</span>
        <input type="hidden" formControlName="message" />
        <app-wysiwyg
          [showPlaceholders]="true"
          [showToolbarItems]="true"
          [value]="mailForm.controls.message.value"
          (valueChanged)="setField('message', $event, false)"
          class="form-control no-padding"
          [class.has-error]="!mailForm.controls.message.valid"
        >
        </app-wysiwyg>
      </div>
      <div class="form-group">
        <span class="label">&nbsp;</span>
        <button pButton [disabled]="!mailForm.valid" (click)="send()">
          Send
        </button>
        <button
          pButton
          severity="secondary"
          [disabled]="!mailForm.valid"
          (click)="close()"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>
}
